import { showAlert } from "./alerts"

export const copyEvent = (copyString: string, caption ?: string) => {
  navigator.clipboard.writeText(copyString).then(()=>showAlert(caption ?? 'Item Copied to Clipboard!','success'))
}